module.exports = __webpack_public_path__ + "static/media/framanverdlaeri.aea5868f.png";